import { FC } from 'react'

import { BACKEND_URL } from 'AppSettings'
import ImageFallback from 'components/molecules/ImageFallback'

import {
  CaseLevelHeaderContainer,
  CaseLevelHeaderContent,
  LawfirmName,
  NameContainer,
  SmallStatusText,
  StatusText
} from './styles'

interface CaseLevelHeaderProps {
  iconUrl?: string | null
  status?: string
  text?: string
}

const CaseLevelHeader: FC<CaseLevelHeaderProps> = ({
  iconUrl = '',
  status = '',
  text = 'Go back'
}) => {
  //const history = useHistory()

  return (
    <CaseLevelHeaderContainer>
      <CaseLevelHeaderContent>
        {/*<CaseLevelHeaderBtn>
          <span className='mdi mdi-arrow-left' onClick={history.goBack} />
  </CaseLevelHeaderBtn>*/}
        <ImageFallback
          alt='Lawfirm image'
          fallback={<span className='mdi mdi-account ml-2' />}
          src={`${BACKEND_URL}${iconUrl}`}
        />
        <NameContainer>
          <LawfirmName>{text}</LawfirmName>
          <SmallStatusText>{status}</SmallStatusText>
        </NameContainer>
        <StatusText>{status}</StatusText>
      </CaseLevelHeaderContent>
    </CaseLevelHeaderContainer>
  )
}

export default CaseLevelHeader
